<template>
    <v-container class="pt-10 pb-16 page-privacy">
      <v-row justify="center">
        <v-col cols="12" md="10">
          <!-- PAGE TITLE -->
          <h1 class="page-title mb-4">SERVICE PARTNER TERMS AND CONDITIONS (USA)</h1>

          <section>
            <h3>1. THE RELATIONSHIP (INDEPENDENT CONTRACTOR)</h3>
            <p>
              This Agreement governs the relationship between OH YES LLC ("the
              Platform") and the service professional or company ("Service
              Partner").
            </p>
            <ul>
              <li>
                <strong>Non-Employment:</strong>
                The Service Partner is an independent contractor. Nothing in this
                agreement creates an employer-employee relationship, partnership,
                or joint venture.
              </li>
              <li>
                <strong>Control of Work:</strong>
                The Service Partner retains full control over the manner, means,
                and methods of performing services. OH YES LLC does not supervise
                or provide training.
              </li>
              <li>
                <strong>Tools & Equipment:</strong>
                The Service Partner is responsible for providing all tools,
                vehicles, and equipment necessary to perform the services.
              </li>
            </ul>
          </section>
  
          <!-- 2 -->
          <section>
            <h3>2. ON-SITE INSPECTION & PRICING AUTONOMY</h3>
            <ul>
              <li>
                <strong>Variable Pricing:</strong>
                Prices listed on the Platform are average estimates only.
              </li>
              <li>
                <strong>Mandatory Quote:</strong>
                The Service Partner must perform a physical inspection and provide
                a final, binding quote upon arrival.
              </li>
              <li>
                <strong>Consent to Start:</strong>
                Work must not begin until the Customer accepts the final quote.
                Additional charges require customer approval if scope changes.
              </li>
              <li>
                <strong>Platform Fee:</strong>
                For each completed job, the Service Partner agrees to pay OH YES
                LLC a Lead/Platform Fee as specified in the Partner App.
              </li>
            </ul>
          </section>
  
          <!-- 3 -->
          <section>
            <h3>3. LICENSING, INSURANCE & COMPLIANCE</h3>
            <ul>
              <li>
                <strong>Professional Licensing:</strong>
                The Service Partner warrants possession of all required state and
                local licenses (e.g., Contractor, Plumber, Electrician).
              </li>
              <li>
                <strong>Liability Insurance:</strong>
                Partners are strongly encouraged (and sometimes required) to
                maintain General Liability Insurance of at least $1,000,000.
              </li>
              <li>
                <strong>Background Checks:</strong>
                The Service Partner consents to periodic background and driving
                record checks.
              </li>
            </ul>
          </section>
  
          <!-- 4 -->
          <section>
            <h3>4. REPRESENTATIONS & WARRANTIES</h3>
            <ul>
              <li>
                Services will be performed in a professional and workmanlike
                manner in accordance with industry standards.
              </li>
              <li>
                Compliance with all Local, State, and Federal laws, including
                building codes and OSHA regulations.
              </li>
              <li>
                Responsibility for self-employment taxes, Social Security, and
                income tax withholdings.
              </li>
            </ul>
          </section>
  
          <!-- 5 -->
          <section>
            <h3>5. INDEMNIFICATION & LIABILITY</h3>
            <ul>
              <li>
                <strong>Partner Liability:</strong>
                The Service Partner assumes full responsibility for any damage,
                injury, or loss caused during service delivery.
              </li>
              <li>
                <strong>Hold Harmless:</strong>
                The Partner agrees to indemnify and hold OH YES LLC harmless from
                claims, lawsuits, or damages arising from Partner actions.
              </li>
              <li>
                <strong>No Platform Warranty:</strong>
                OH YES LLC does not guarantee lead volume or income.
              </li>
            </ul>
          </section>
  
          <!-- 6 -->
          <section>
            <h3>6. CUSTOMER INTERACTION & SAFETY</h3>
            <ul>
              <li>
                <strong>Professional Conduct:</strong>
                Harassment, discrimination, or unsafe behavior results in
                immediate termination.
              </li>
              <li>
                <strong>Pandemic Protocols:</strong>
                Compliance with CDC and State health guidelines is mandatory when
                applicable.
              </li>
              <li>
                <strong>Direct Solicitation:</strong>
                Partners may not solicit off-platform business from OhYes
                customers for a period of six (6) months.
              </li>
            </ul>
          </section>
  
          <!-- 7 -->
          <section>
            <h3>7. TERMINATION</h3>
            <ul>
              <li>
                <strong>At-Will:</strong>
                Either party may terminate this agreement at any time.
              </li>
              <li>
                <strong>Immediate Suspension:</strong>
                OH YES LLC may suspend access immediately for fraud, safety
                violations, or low ratings.
              </li>
            </ul>
          </section>
  
          <!-- 8 -->
          <section>
            <h3>8. DISPUTE RESOLUTION (ARBITRATION)</h3>
            <p>
              All disputes shall be resolved through binding arbitration in the
              State of Illinois. Both parties waive the right to participate in
              class-action lawsuits.
            </p>
          </section>
  
          <!-- IMPLEMENTATION NOTES -->
          <section>
            <h3>Implementation for OH YES LLC</h3>
            <ul>
              <li>
                Require electronic acceptance ("I Agree") during Partner
                onboarding.
              </li>
              <li>
                Mandate license and insurance document uploads before lead
                access.
              </li>
              <li>
                Collect W-9 details to issue 1099-NEC forms for earnings over
                $600.
              </li>
            </ul>
          </section>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "PartertermsUSA",
  };
  </script>
  
  <style scoped>
  .page-title { font-size: 34px; font-weight: 700; }

  section {
    margin-bottom: 28px;
  }
  
  h3 {
    font-size: 16px;
    font-weight: 600;
    margin-top: 18px;
    margin-bottom: 6px;
  }
  
  p,
  li {
    font-size: 15px;
    color: #444;
    line-height: 1.7;
  }
  
  ul {
    padding-left: 20px;
  }
  </style>
  